import script from "./CourseStudentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseStudentModal.vue?vue&type=script&setup=true&lang=js"

import "./CourseStudentModal.vue?vue&type=style&index=0&id=6556697e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6556697e"]])

export default __exports__